import * as types from '../types'

export default {
  state: {
    consign: {}
  },
  getters: {
    consign: state => {
      return state.consign
    }
  },
  mutations: {
    [types.SET_CONSIGN](state, data) {
      state.consign = data
    }
  },
  actions: {
    [types.SET_CONSIGN]({ commit, state }, data) {
      commit(types.SET_CONSIGN, data)
    }
  }
}
